module.exports = __webpack_public_path__ + "img/10-imperial-black-diamond.e6f3c570.png";